import { type FunctionComponent } from 'react';
import { useEffect } from 'react';
import { AlertDialog } from '../../atoms/AlertDialog/AlertDialog';
import { useTranslation } from '../../i18n/resources';
import { SuccessCircle } from '../../icons/SuccessCircle';
import styles from './OnboardingCompleteAlertDialog.module.css';

export type OnboardingCompleteAlertDialogProps = {
  onClose: () => void;
  userSelectionSkipped?: boolean;
};

export const OnboardingCompleteAlertDialog: FunctionComponent<
  OnboardingCompleteAlertDialogProps
> = ({ onClose, userSelectionSkipped = true }) => {
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 5000);
  });

  return (
    <AlertDialog
      onClose={onClose}
      open
      padding="small"
      size="small"
      title={
        userSelectionSkipped
          ? t('onboarding', 'skipped_groups_title')
          : t('onboarding', 'groups_confirmation_title')
      }
    >
      <div className={styles.confirmationDescription}>
        <SuccessCircle />
        <p className={styles.thankYou}>{t('onboarding', 'thank_you')}</p>
        <p className={styles.confirmationText}>
          {t('onboarding', 'description')}
        </p>
      </div>
    </AlertDialog>
  );
};
